<div *ngIf="!showSpinner" style='margin-right: 18px;'>
  <div class="report-tabs-row" *ngIf="reportTabs.length > 1">
    <button *ngFor="let tab of reportTabs; let i = index"
            type="button"
            class="report-tab-btn"
            [class.report-tab-btn-active]="i === selectedReportTabIndex"
            (click)="selectReportTab(i)">
      {{ tab.label }}
    </button>
  </div>
  <powerbi-report powerbi-type="report"
    [embedConfig]="reportConfig" [eventHandlers]="eventHandlers"
    style="height: 800px; width: 100%;"></powerbi-report>
</div>
<ngx-loading *ngIf="showSpinner" [show]="showSpinner" [config]="{ backdropBorderRadius: '3px' }"
  [template]="customLoadingTemplate">
</ngx-loading>
<ng-template #customLoadingTemplate>
  <div class="custom-class-loader">
    <div class="spinner-container">
      <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
    </div>
  </div>
</ng-template>